<template>
    <a-drawer
        :closable="true"
        :destroyOnClose="true"
        :keyboard="false"
        :maskClosable="false"
        :visible="visible"
        :width="550"
        @close="close"
        title="上传图片"
        v-bind="$attrs">
        <a-empty v-if="closed" description="拍摄已结束" style="margin-top:10%;"/>
        <template v-else>
            <UploadForm :album-id="album.id" :resize-long="resizeLong" @start="start" ref="uploadForm" v-if="!uploading"/>
            <UploadTable :album-id="album.id" :resize-long="resizeLong" @complete="complete" ref="uploadTable" v-if="uploading"/>
        </template>
    </a-drawer>
</template>

<script>
    import func from "../../../../../utils/func";
    import UploadForm from "./UploadForm";
    import UploadTable from "./UploadTable";

    export default {
        name: "UploadDrawer",
        components: {UploadTable, UploadForm},
        props: ["album", "member"],
        data() {
            return {
                visible: false,
                uploading: false,
                closable: false,
                closed: this.member.closed,
                resizeLong: this.album.config.flow_policy.resize_long,
            }
        },
        methods: {
            open() {
                this.visible = true;
                this.closable = false;
                this.uploading = false;
            },
            close() {
                if (this.uploading) {
                    this.closable = true;
                    this.$refs.uploadTable.closeUpload();
                } else {
                    this.visible = false;
                    this.$emit("close");
                }
            },
            start(files, params) {
                this.uploading = true;
                func.sleep(250).then(() => {
                    this.$refs.uploadTable.startUpload(files, params);
                });
            },
            complete() {
                this.uploading = false;
                this.visible = !this.closable;
                this.closable && this.$emit("close");
            }
        }
    }
</script>
